type EventBusType = {
  on(event: string, callback: Function): void
  emit(event: string, data?: {}): void
  off(event: string, callback: Function): void
}

const eventBus: EventBusType = {
  on(event: string, callback: Function) {
    document.addEventListener(event, ((e: CustomEvent) => callback(e.detail)) as EventListener)
  },
  emit(event: string, data?: {}) {
    document.dispatchEvent(new CustomEvent(event, { detail: data }))
  },
  off(event: string, callback: Function) {
    document.removeEventListener(event, callback as EventListener)
  }
}

export default eventBus
